//
// Copyright 2026 DXOS.org
//
import * as Schema from 'effect/Schema';
import * as Rpc from 'effect/unstable/rpc/Rpc';
import * as RpcGroup from 'effect/unstable/rpc/RpcGroup';
import { serviceError } from './service-rpc.js';
//
// RPC message schemas.
//
export const StartRequest = Schema.Struct({
    origin: Schema.String,
    /** Key for the iframe resource lock used to determine when the service is closing. */
    lockKey: Schema.optional(Schema.String),
});
/**
 * Iframe-to-worker RPCs.
 *
 * Effect RPC definitions for the iframe/tab -> worker control channel (`dxos.iframe.WorkerService`).
 * Runs natively over the system {@link MessagePort}, replacing the legacy protobuf peer.
 */
export class Rpcs extends RpcGroup.make(Rpc.make('start', {
    payload: StartRequest,
    error: serviceError,
}), Rpc.make('stop', {
    error: serviceError,
})).prefix('WorkerService.') {
}
//# sourceMappingURL=WorkerService.js.map